import React from 'react'

function SpriteButton({toggleTwoD}) {
  return (
    <div
      className='two-d text-center text-2xl text-white font-bold p-3 mt-3 transition-all duration-300 cursor-pointer rounded-xl border border-white border-opacity-15 hover:border-opacity-30 hover:scale-105 hover:translate-x-1'
      style={{
        background: 'rgba(255, 255, 255, 0.08)',
        backdropFilter: 'blur(10px)',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)'
      }}
      onClick={toggleTwoD}>
        2DS
    </div>
  )
}

export default SpriteButton